export default __webpack_public_path__ + "static/media/caribou.ea4321e3.jpg";